import styled from 'styled-components';

export const FeatureButtonIconWrapper = styled.div`
  width: 65%;
  height: 65%;
  @media only screen and (max-width: 1000px) {
    width: 60%;
    height: 60%;
  }
  @media only screen and (max-width: 768px) {
    width: 70%;
    height: 70%;
  }
  @media only screen and (max-width: 425px) {
    width: 90%;
    height: 90%;
  }
  @media only screen and (max-width: 375px) {
    width: 100%;
    height: 100%;
  }
`;
